import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PageWrap } from '@minerva-analytics/pantheon';
import HTMLTemplate from '../../components/HTMLTemplate';

import {
  StyledCard,
} from './Legal.styles';

const commonInfo = {
  dba: `Quizhive Trivia`,
  email: `support@quizhive.com`,
  domain: `www.quizhive.com`,
  name: `Quizhive Trivia`,
  address1: `1770 Massachusetts Ave`,
  address2: `#616`,
  state: `Cambridge, MA 02140`,
  country: `USA`,
};

const legalInfo = {
  "/calpolicy": {
    templateUrl: `https://storage.googleapis.com/minerva-legal/CalPolicy.html`,
    variables: { ...commonInfo },
  },
  "/cookie": {
    templateUrl: `https://storage.googleapis.com/minerva-legal/CookiePolicy.html`,
    variables: { ...commonInfo },
  },
  "/terms": {
    templateUrl: `https://storage.googleapis.com/minerva-legal/Terms.html`,
    variables: { ...commonInfo },
  },
  "/privacy": {
    templateUrl: `https://storage.googleapis.com/minerva-legal/Privacy.html`,
    variables: { ...commonInfo },
  },
};

const Legal = ({
  location,
}) => {
  const { pathname } = location;

  return (
    <PageWrap>
      <StyledCard>
        <HTMLTemplate
          {...legalInfo[pathname]}
        />
      </StyledCard>
    </PageWrap>
  );
};

Legal.propTypes = {
  location: PropTypes.object,
};

export default withRouter(Legal);
